import React from "react";
import { type NextPage } from "next";
import { Page } from "components/page";
import { HalfHero } from "components/half-hero";
import { StackedLogos } from "components/logos";
import { SecurityDiptychs } from "components/platform/security/security-diptychs";
import { getLandingPageProps, getPageMetaImage, type LandingPageProps } from "utils";
import { SecurityFeatures } from "components/content";
import heroImage from "../../../public/assets/platform/security/hero.png";

const Security: NextPage<LandingPageProps> = ({ page, announcementBanner, defaultLogos }) => {
  return (
    <Page
      title={page.metaTitle}
      description={page.metaDescription}
      image={getPageMetaImage({ src: page.metaImageUrl, alt: page.metaTitle })}
      announcementBanner={announcementBanner}
    >
      <HalfHero
        eyebrow={page.eyebrow}
        title={page.title}
        description={page.description}
        image={heroImage}
        imageRatio={2 / 1}
        imageObjectFit="contain"
      />

      <StackedLogos customers={defaultLogos} />

      <SecurityFeatures />

      <SecurityDiptychs />
    </Page>
  );
};

export default Security;

export const getStaticProps = getLandingPageProps("/platform/security", { loadDefaultLogos: true });
